<template>
  <div class="mb-3">
    <b-row no-gutters>
      <b-col xl="2" md="2" class="d-none d-md-block">
        <span>{{ planTitleFa }}</span>
      </b-col>
      <b-col class="text-left" xl="10" md="10" cols="12" style="direction: ltr">
        <b-row no-gutters>
          <b-col xl="2" md="3" cols="6" order="1">
            <b-icon font-scale="1.2" :icon="icon" class="mr-2"></b-icon>
            <span>{{ planTitleEn }}</span>
          </b-col>
          <b-col xl="8" md="7" cols="12" order="3" order-md="2">
            <vue-slider
              class="mx-md-3"
              :value="value"
              @change="update"
              :dotSize="15"
              :min="min"
              :max="max"
              :interval="interval"
              lazy
              adsorb
              hide-label
              marks
              :use-keyboard="false"
              :disabled="disabled"
            />
          </b-col>
          <b-col
            xl="2"
            md="2"
            cols="6"
            class="plan-title-value text-right text-md-left"
            order="2"
            order-md="3"
          >
            {{ value }}
            <span>{{ unit }}</span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
export default {
  components: {
    VueSlider
  },
  name: "SliderRengePlanItem",
  props: {
    icon: { type: String, required: true },
    planTitleFa: { type: String, required: true },
    planTitleEn: { type: String, required: true },
    value: { type: Number, required: true, default: 0 },
    unit: { type: String, required: true },
    min: { type: Number, required: true, default: 0 },
    max: { type: Number, required: true, default: 10 },
    interval: { type: Number, required: true, default: 1 },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    update: function(val) {
      this.$emit("update", val);
    }
  }
};
</script>

<style lang="scss">
.plan-title {
  color: #3e89d1;

  &-value {
    font-size: 13px;
  }
}
</style>
